import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as enums from '../enums'

import * as log from './log'

export const DOC = gql`
  ${log.DOC}
  fragment FragmentSpaceRecord on SpaceRecord {
    id
    name
    code
    description
    occupierId
    roomTypeId
    roomTypeCategory
    sqft
    anomalies
    clusterId
    comment
    surveyStatus
    surveyStatusLite
    ancestors
    entityId
    history {
      ...FragmentSpaceRecordHistoryLog
    }
    lastUpdated {
      ...FragmentSpaceRecordHistoryLog
    }
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentSpaceRecordFragment,
  ents.extra.space.Record
>({
  ancestors: graphql.transformers.OUT.validate(
    graphql.transformers.OUT.json(),
    ents.extra.space.Record.AncestorsLookup.assertIsAncestorsLookup,
  ),
  anomalies: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(enums.anomaly.TRANSFORMER, {
      onNullish: 'remove',
    }),
    [],
  ),
  clusterId: () => undefined,
  code: transformers.PASS_THROUGH,
  comment: transformers.PASS_THROUGH,
  description: transformers.PASS_THROUGH,
  entityId: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.models.Entity.Id.isId,
  ),
  // NOTE: not exposed through GQL, the functional usage carries it instead
  functionalizationMethodology: () => undefined,
  history: graphql.transformers.OUT.default(
    graphql.transformers.OUT.list(
      graphql.transformers.OUT.validate(
        log.TRANSFORMER,
        TypeAsserter.assertIsNotNullish,
      ),
    ),
    [],
  ),
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.data.Record.Id.isId,
  ),
  lastUpdated: log.TRANSFORMER,
  name: transformers.PASS_THROUGH,
  occupierId: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.Organization.Id.isId,
  ),
  roomTypeId: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.RoomType.Id.isId,
  ),
  roomTypeCategory: enums.roomTypeCategory.TRANSFORMER,
  sqft: transformers.PASS_THROUGH,
  surveyStatus: enums.surveyStatus.TRANSFORMER,
  surveyStatusLite: enums.surveyStatus.TRANSFORMER,
})
